export default __webpack_public_path__ + "static/media/partners-bg.47306b1c.png";